import { BaseModel } from "model/BaseModel";
import InspecaoQualidade from "./InspecaoQualidade";
import PlanoInspecao from "./PlanoInspecao";
import { BaseEditModel } from "model/BaseEditModel";

export default class ItemPlanoInspecao implements BaseEditModel{
    id: number;
    codigo: string = "";
    key: string = "";
    sequencial: number;
    valorAlvo: number;
    valorMinimo: number;
    valorMaximo: number;
    planoInspecao: PlanoInspecao|null;
    inspecaoQualidade: InspecaoQualidade;

    constructor(
        id: number = 0,
        sequencial: number = 0,
        valorAlvo: number = 0,
        valorMinimo: number = 0,
        valorMaximo: number = 0,
        planoInspecao: PlanoInspecao|null = null,
        inspecaoQualidade: InspecaoQualidade = new InspecaoQualidade()
    ) {
        this.id = id;
        this.sequencial = sequencial;
        this.valorAlvo = valorAlvo;
        this.valorMinimo = valorMinimo;
        this.valorMaximo = valorMaximo;
        this.planoInspecao = planoInspecao;
        this.inspecaoQualidade = inspecaoQualidade;
    }
}